import React from "react";
import axios from 'axios';
import Slider from "react-slick";
import './HomeSlider.css';
class HomeSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            slider: []
        }
        
    }; 
    componentDidMount(){
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Homepage Section/Home Slider'), {
            headers : { 
        'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({slider:response.data.data.section_cards})
             //console.log(response.data.data.section_cards)  
             //alert()
        })
        .catch(response=>{
             console.log(response+' api/resource/Homepage Section/Homeslider')
             //alert("no")
        })
    }
    render() {
        var settings = {
            slidesToShow: 1,
            fade: true,
            speed: 500,
            slidesToScroll: 1,
            fade: true,
            loop: true,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    dots: false
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                  }
                }
              ]
          
        }
       
         return<div className="container-fluid mb-5">
          <div className="row">
                    <div className="home-slider">
                        <div className="hero-slider-active-2 nav-style-1 nav-style-1-green">
                        <Slider {...settings}>
                            {this.state.slider.map((itm,k)=>{
                            return(
                                    <div key={k} className="slider-item" >
                                      {(() => {
                                        if (itm.text_position =="Left") {
                                           return (
                                            <div className="slider-head-left">
                                                {itm.subtitle ? <h3 className="subtitile-font" style={{color: itm.text_color}}> {itm.subtitle}</h3> :'' }
                                                {itm.content ?  <p className="subtitile-font-para" style={{color: itm.text_color}}>{itm.content}</p> :''}
                                            </div>
                                           )}
                                          else if (itm.text_position =="Center") {
                                            return (
                                             <div className="slider-head-center">
                                                 {itm.subtitle ? <h3 className="subtitile-font" style={{color: itm.text_color}}> {itm.subtitle}</h3> :'' }
                                                 {itm.content ?  <p className="subtitile-font-para" style={{color: itm.text_color}}>{itm.content}</p> :''}
                                             </div>
                                            )}
                                            else  {
                                              return (
                                               <div className="slider-head-end">
                                                   {itm.subtitle ? <h3 className="subtitile-font" style={{color: itm.text_color}}> {itm.subtitle}</h3> :'' }
                                                   {itm.content ?  <p className="subtitile-font-para" style={{color: itm.text_color}}>{itm.content}</p> :''}
                                               </div>
                                              )}
                                        })()}   

                                        <img src={process.env.REACT_APP_API_URL + itm.image} className="home-slider-imge" width="100%" alt="img" />
                                        
                                    </div>)
                            })} 
                        </Slider>
                        </div>
                    </div>
                </div>
                </div>
              }
            }
            export default HomeSlider;